/**
 * Navigation configuration for Gym module
 * Uses labelKey for i18n translation (transformed by useNavigation composable)
 */
export const navigationSections = [
  {
    key: 'main',
    items: [
      {
        name: 'dashboard',
        path: '/',
        icon: 'dashboard',
        labelKey: 'nav.dashboard',
      },
      {
        name: 'members',
        path: '/members',
        icon: 'people',
        labelKey: 'nav.members',
      },
      {
        name: 'plans',
        path: '/plans',
        icon: 'calendar',
        labelKey: 'nav.plans',
      },
      {
        name: 'payments',
        path: '/payments',
        icon: 'payments',
        labelKey: 'nav.payments',
      },
      {
        name: 'messages',
        path: '/messages',
        icon: 'chat',
        labelKey: 'nav.messages',
      },
    ],
  },
  {
    key: 'settings',
    items: [
      {
        name: 'settings',
        path: '/settings',
        icon: 'settings',
        labelKey: 'nav.settings',
      },
    ],
  },
]
